import { styled } from '@linaria/react';
import { motion } from 'framer-motion';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
// Slide
const _exp = /*#__PURE__*/() => motion.div;
export const Pinchable = /*#__PURE__*/styled(_exp())({
  name: "Pinchable",
  class: "p1lt876m",
  propsAsIs: true
});

// VirtualizedGallery
export const VirtualizedGalleryWrapper = /*#__PURE__*/styled('div')({
  name: "VirtualizedGalleryWrapper",
  class: "v1hs8989",
  propsAsIs: false
});
export const SliderWrapper = /*#__PURE__*/styled('div')({
  name: "SliderWrapper",
  class: "s1wojzvp",
  propsAsIs: false
});
export const SlideNumberWrapper = /*#__PURE__*/styled('div')({
  name: "SlideNumberWrapper",
  class: "spr0jp2",
  propsAsIs: false
});

// PaginationButtons
const _exp6 = /*#__PURE__*/() => motion.div;
export const ButtonsWrapper = /*#__PURE__*/styled(_exp6())({
  name: "ButtonsWrapper",
  class: "b1nguc7m",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => Button;
export const BackwardButton = /*#__PURE__*/styled(_exp7())({
  name: "BackwardButton",
  class: "b1kea1ni",
  propsAsIs: true
});
const _exp9 = /*#__PURE__*/() => Button;
export const ForwardButton = /*#__PURE__*/styled(_exp9())({
  name: "ForwardButton",
  class: "fufbre9",
  propsAsIs: true
});
const _exp11 = /*#__PURE__*/() => Icon;
export const IconComponent = /*#__PURE__*/styled(_exp11())({
  name: "IconComponent",
  class: "i165lpcp",
  propsAsIs: true
});

// CurrentSlideIndicators
export const IndicatorWrapper = /*#__PURE__*/styled('div')({
  name: "IndicatorWrapper",
  class: "i1nlr8ep",
  propsAsIs: false
});
const _exp12 = /*#__PURE__*/() => motion.div;
export const DotIndicator = /*#__PURE__*/styled(_exp12())({
  name: "DotIndicator",
  class: "dsv97ja",
  propsAsIs: true
});

// LightboxGalleryMobile
export const backgroundColorStyles = "b1vt31t4";
export const OverlayContent = /*#__PURE__*/styled('div')({
  name: "OverlayContent",
  class: "ojidq0n",
  propsAsIs: false
});
export const GalleryWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryWrapper",
  class: "g1k4a67x",
  propsAsIs: false
});
export const Footer = /*#__PURE__*/styled('div')({
  name: "Footer",
  class: "f19zy777",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");